import { render, staticRenderFns } from "./TouchpointBrickSettings.vue?vue&type=template&id=daf0cb6a&scoped=true&"
import script from "./TouchpointBrickSettings.vue?vue&type=script&lang=js&"
export * from "./TouchpointBrickSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf0cb6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daf0cb6a')) {
      api.createRecord('daf0cb6a', component.options)
    } else {
      api.reload('daf0cb6a', component.options)
    }
    module.hot.accept("./TouchpointBrickSettings.vue?vue&type=template&id=daf0cb6a&scoped=true&", function () {
      api.rerender('daf0cb6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/BrickSettings/Touchpoint/TouchpointBrickSettings.vue"
export default component.exports